<div id="main-wrapper" style="margin-bottom: 40px;">
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <div class="container-fluid" style="padding: 0;">
    <app-header (found)="handleResults($event)"></app-header>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/providerportal" href="#" style="color: #23499E;">Providerportal</a>
        </li>
        <li class="breadcrumb-item">
          <a routerLink="/providerportal/site_Administration" href="#" style="color: #23499E;">Manage Users</a>
        </li>
        <li class="breadcrumb-item active" style="font-family: Myriad Pro" aria-current="page">Attach to Site</li>
      </ol>
    </nav>
    <div class="row  addtositePage">
      <app-search-results [resultGridList]="data"></app-search-results>

      <div class="row userSites">
        <div class="col-md-4">
          @if (actualUserSites.length >0 && false) {
            <div class=" currentUserSiteList">
              <br>
                <p class="test">My Sites:</p>
                @for (user of actualUserSites; track user) {
                  <ul class="list-group">
                    <li class="list-group-item list-group-item-action listStyle" style="cursor: pointer; word-break: break-all; background-color: lightgray; border-color: black;">
                      {{user['siteName']}}
                    </li>
                  </ul>
                }
              </div>
            }
            @if (actualUSerSitesIsEmpty) {
              <div class="currentUserSiteList">
                <br>
                  <p class="test">You are not assigned to any Site.</p>
                </div>
              }
              @if ( users['1'].length > 1) {
                <div class=" userList">
                  <p class="test">Active Users:</p>
                  @for (user of users['1'] | sort :'name'; track user) {
                    <ul class="list-group">
                      @if (user['userName'] !== userName) {
                        <li (click)="listUserSites(user.userName)" [ngClass]="{'activeClass': selected.userName == user.userName}"
                          class="list-group-item list-group-item-action listStyle" style="cursor: pointer; word-break: break-all"
                          >
                        {{user.name}}</li>
                        } <br>
                      </ul>
                    }
                  </div>
                }
                @if ( users['1'].length === 1) {
                  <div class="userList">
                    <br>
                      <p class="test">No Active Users</p>
                    </div>
                  }

                </div>

                @if (selected['userName'] !== '') {
                  <div class="col-md-8 siteList">
                    <br>
                      <div class="col-md-12">
                        @if (updateMessage !== '') {
                          <div class="col-md-12">
                            <p class="row updateMessage"> {{updateMessage}}</p>
                          </div>
                        }
                        @if (failureMessage !== '') {
                          <div class="col-md-12">
                            <p class="row failureMessage"> {{failureMessage}}</p>
                          </div>
                        }
                        @if (actualFilteredUserSites.length>0||selectedUserSites!=null) {
                          <div class="col-md-12 updateBtn">
                            <button (click)=postSites() type="button" class="btn btn-primary carelon-primary-btn">Update</button>
                          </div>
                        }
                      </div>
                      <br>
                        @if (selectedUserSites.length>0) {
                          <div>
                            <p>Click - sign to remove sites for user <b>{{selected.userName}}</b></p>
                          </div>
                          <br>
                            @for (sites of selectedUserSites; track sites) {
                              <ul class="list-group">
                                <a class="list-group-item list-group-item-action listStyle text-left mb-4">
                                  <div class="row">
                                    <div class="col-md-11 col-xs-8">
                                      {{sites.siteName}}
                                    </div>
                                    @if (sites.ownSite) {
                                      <div class="col-md-1 col-xs-4" >
                                        <!-- <span (click)=removeSites(sites) class="glyphicon glyphicon-minus-sign pull-right" aria-hidden="true"
                                      style="color: red; cursor: pointer;"></span> -->
                                      <span (click)=removeSites(sites)>
                                        <i class="bi bi-dash-circle text-danger" style="color: red; cursor: pointer;">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                                          </svg>
                                        </i>
                                      </span>
                                    </div>
                                  }
                                </div>
                              </a>
                            </ul>
                          }
                        }
                        @if (selectedUserSites.length ===0) {
                          <p>No Sites Associated to the user <b>{{selected.userName}}</b></p>
                        }
                        @if (actualFilteredUserSites.length > 0) {
                          <hr/>
                          @if (selectedUserSites) {
                            <div>
                              <p>Click + sign to add below sites to user <b>{{selected.userName}}</b></p>
                            </div>
                          }
                          <br>
                            @for (sites of actualFilteredUserSites; track sites) {
                              <ul class="list-group">
                                <a class="list-group-item list-group-item-action listStyle mb-4">
                                  <div class="row">
                                    <div class="col-md-11 col-xs-8">
                                      {{sites.siteName}}
                                    </div>
                                    <div class="col-md-1 col-xs-4">
                                      <!-- <span (click)=addSites(sites) class="glyphicon glyphicon-plus-sign pull-right" aria-hidden="true"
                                    style="color: green; cursor: pointer;"></span> -->
                                    <span (click)=addSites(sites)>
                                      <i class="bi bi-plus-circle" style="color: green; cursor: pointer;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </a>
                            </ul>
                          }
                        }
                        <br>
                        </div>
                      }
                      @if (selected['userName'] === '') {
                        <div class="col-md-4 noSiteList">
                          <p class="row noSiteListText"> Please select a active user to list sites</p>
                        </div>
                      }
                      <br>
                      </div>
                    </div>
                  </div>
                  <br><br><br>
                  <app-footer ></app-footer>
                </div>